import React from "react";

// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Snackbar from "../../components/Snackbar/Snackbar";
import {useHistory} from "react-router-dom";
import fetchAPI from "../../util/swt/fetchAPI";
import {METHOD} from "../../util/enum/method";
import {endpoints} from "../../util/swt/endpoints";
import {consumeLogoutReason, setCompanySession, setTokenUser, setUserSession} from "../../util/common/Common";
import Cipher from "../../util/common/Cipher";
import {ID_EMPRESA} from "../../util/common/const";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {Email, Visibility, VisibilityOff} from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(styles);

export default function LoginPage() {
    const history = useHistory();
    const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [alert, setAlert] = React.useState(false);
    const [alertError, setAlertError] = React.useState(false);
    const [message, setMessage] = React.useState("");
    const [sessionAlert, setSessionAlert] = React.useState(false);
    const [sessionMessage, setSessionMessage] = React.useState("");
    const [sessionColor, setSessionColor] = React.useState("warning");
    // temporal password flow will redirect to a dedicated page
    const [showPassword, setShowPassword] = React.useState(false);

    React.useEffect(() => {
        let id = setTimeout(function () {
            setCardAnimation("");
        }, 500);
        // Specify how to clean up after this effect:
        return function cleanup() {
            window.clearTimeout(id);

        };
    });

    React.useEffect(() => {
        const reason = consumeLogoutReason();
        if (reason === 'inactivity') {
            setSessionMessage('Su sesión se cerró por inactividad.');
            setSessionColor('warning');
            setSessionAlert(true);
        } else if (reason === 'expired') {
            setSessionMessage('Su sesión ha expirado. Vuelva a iniciar sesión.');
            setSessionColor('danger');
            setSessionAlert(true);
        }
    }, []);

    const handleSubmit = async event => {
        event.preventDefault();

        if (email === "" && password === "") {
            setAlert(true);
            setTimeout(
                function () {
                    setAlert(false)
                },
                4000
            );
            return;
        }
        if (email === "" || password === "") {
            setAlert(true);
            setTimeout(
                function () {
                    setAlert(false)
                },
                4000
            );
            return;
        }

        try {

            const correo = await Cipher.encrypting(email)
            const clave = await Cipher.encrypting(password)

            const response = await fetchAPI(endpoints.login, METHOD.POST, {usernameOrEmail: correo, password: clave})
            if (response.user.state === 2) {
                // usuario con contraseña temporal -> redirigir a la página de cambio de contraseña
                history.push('/auth/change-password', { email });
            } else {
                setTokenUser(response);
                setUserSession(response.user);

                const dataEmpresa = await fetchAPI(endpoints.empresa + ID_EMPRESA + '/')
                setCompanySession(dataEmpresa);

                //cargar menús dinámicos
                const menus = await fetchAPI(endpoints.userEmpMnByUser + '?userId=' + response.user.id + '&roleId=' + response.user.roles[0].id)
                localStorage.removeItem("sessionMens");
                let menusStr = JSON.stringify(menus);
                localStorage.setItem("sessionMens", Cipher.encrypting(menusStr));


                history.push('/admin/home')
            }
        } catch (e) {
            setMessage(e.message);
            setAlertError(true);
            setTimeout(
                function () {
                    setAlertError(false)
                },
                4000
            );
        }


    };

    const classes = useStyles();
    return (
        <div className={classes.container}>
            <GridContainer justify="center">
                <Snackbar
                    place="tr"
                    color="warning"
                    icon={AddAlert}
                    message="Atención: Debe completar los campos."
                    open={alert}
                    closeNotification={() => setAlert(false)}
                    close
                />
                <Snackbar
                    place="tr"
                    color="danger"
                    icon={AddAlert}
                    message={message}
                    open={alertError}
                    closeNotification={() => setAlertError(false)}
                    close
                />
                <Snackbar
                    place="tr"
                    color={sessionColor}
                    icon={AddAlert}
                    message={sessionMessage}
                    open={sessionAlert}
                    closeNotification={() => setSessionAlert(false)}
                    close
                />
                <GridItem xs={12} sm={8} md={4}>
                    <form onSubmit={handleSubmit}>
                        <Card
                            login
                            className={`${classes.cardHidden} ${cardAnimaton}`}
                            style={{
                                borderRadius: "20px",
                                boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                backdropFilter: "blur(12px)",

                                overflow: "hidden",
                            }}
                        >
                            <CardHeader
                                className={`${classes.cardHeader} ${classes.textCenter}`}
                                style={{
                                    background: "linear-gradient(135deg, #0BA360 0%, #3FD1A7 100%)",
                                    color: "#fff",
                                    padding: "25px",
                                }}
                            >
                                <h4 className={classes.cardTitle} style={{ fontWeight: "600" }}>
                                    Iniciar Sesión
                                </h4>
                            </CardHeader>

                            <CardBody style={{ padding: "30px 25px" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Correo Electrónico"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className={classes.input}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <Email style={{ color: "#0BA360" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Contraseña"
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className={classes.input}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    edge="start"
                                                    size="small"
                                                >
                                                    {showPassword ? <VisibilityOff style={{ color: "#0BA360" }} /> : <Visibility style={{ color: "#0BA360" }} />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </CardBody>

                            <CardFooter className={classes.justifyContentCenter} style={{ padding: "20px" }}>
                                <Button
                                    color="info"
                                    size="lg"
                                    block
                                    type="submit"
                                    style={{
                                        background: "linear-gradient(90deg, #0BA360 0%, #3FD1A7 100%)",
                                        borderRadius: "10px",
                                        fontWeight: "bold",
                                        padding: "12px",
                                        color: "#fff",
                                        fontSize: "16px",
                                    }}
                                >
                                    Login
                                </Button>
                                <div style={{ marginTop: 12, textAlign: 'center' }}>
                                    <Button
                                        color="transparent"
                                        size="sm"
                                        onClick={() => history.push('/auth/forgotpassword')}
                                        style={{ textTransform: 'none', color: '#0BA360', fontWeight: 600 }}
                                    >
                                        ¿Olvidaste tu contraseña?
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </form>
                </GridItem>
            </GridContainer>
            {/* TemporalPasswordDialog replaced by dedicated page /auth/change-password */}
        </div>
    );
}
